export default __webpack_public_path__ + "static/media/openStreetMaps.fb2b3b12.png";